import { Pipe, PipeTransform } from '@angular/core';
import { StorageLevel, StorageLevelV2, SystemDetails } from '@twaice-fe/shared/models';
import { StorageLevelIdentifierUtils } from './storage-level-identifier.utils';
import { CustomerNameTranslationService } from './customer-name-translation.service';

@Pipe({
  name: 'storageLevelToCustomerLevelName',
  pure: false,
  standalone: true,
})
export class StorageLevelToCustomerLevelNamePipe implements PipeTransform {
  constructor(private customerNameTranslationService: CustomerNameTranslationService) {}

  transform(
    level: StorageLevel | StorageLevelV2,
    capitalized: boolean = false,
    componentCount: number | undefined = undefined,
    includeCount: boolean = false,
    system: Pick<SystemDetails, 'customerBk' | 'systemBk'> | undefined = undefined
  ): string {
    return this.customerNameTranslationService.replaceLevelIdentifiers(
      StorageLevelIdentifierUtils.toLevelString(level, capitalized, componentCount, includeCount),
      undefined,
      system
    );
  }
}
